import React from 'react';
import { Box, CircularProgress } from '@material-ui/core';

import styles from '../Components/main.module.css';

const Loading = () => {
  return (
    <Box className={styles.loading}>
      <CircularProgress />
    </Box>
  );
};

export default Loading;
